var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11.6074,
    width: 15,
    height: 15,
    transform: "rotate(-45 1 11.6074)",
    fill: "#160D4D",
    stroke: "#160D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.136 10.792H15.32V11.928H12.136V15.224H10.984V11.928H7.8V10.792H10.984V7.48H12.136V10.792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusZoom);
export default __webpack_public_path__ + "static/media/plus-zoom.c08889f6ce1c37eefe79bbe7f73195b2.svg";
export { ForwardRef as ReactComponent };